import { IUserEntityAttributes, UserEntity } from 'Models/Entities';
import moment from 'moment';
import { IUser } from 'Views/Components/CRUD/UserList';

export enum UserStatus {
	ACTIVE = 'ACTIVE',
	PENDING = 'PENDING',
	INACTIVE = 'INACTIVE'
}

export type UserStatusFields = {
	lastAccessed: Date | null;
	lockoutEnd: Date | null;
	emailConfirmed: boolean
};

export const getStatus = (
	lockoutEnd: Date | null | string,
	emailConfirmed: boolean,
) => {
	const now = new Date();
	if (moment(lockoutEnd).isAfter(now)) {
		return UserStatus.INACTIVE;
	}

	if (!emailConfirmed) {
		return UserStatus.PENDING;
	}

	return UserStatus.ACTIVE;
};

export const getStatusForUser = (user: IUser) => {
	if (user.lockedOut) {
		return UserStatus.INACTIVE;
	}

	if (!user.emailConfirmed) {
		return UserStatus.PENDING;
	}

	return UserStatus.ACTIVE;
};
